<table>
  <tbody>

  <tr *ngIf="config.showLetters">
    <td *ngIf="config.showNegative"></td>
    <td id="dp-years-label" *ngIf="config.showYears">{{ config.labels.years }}</td>
    <td id="dp-months-label" *ngIf="config.showMonths">{{ config.labels.months }}</td>
    <td id="dp-weeks-label" *ngIf="config.showWeeks">{{ config.labels.weeks }}</td>
    <td id="dp-days-label" *ngIf="config.showDays">{{ config.labels.days }}</td>
    <td id="dp-hours-label" *ngIf="config.showHours">{{ config.labels.hours }}</td>
    <td id="dp-minutes-label" *ngIf="config.showMinutes">{{ config.labels.minutes }}</td>
    <td id="dp-seconds-label" *ngIf="config.showSeconds">{{ config.labels.seconds }}</td>
  </tr>

  <tr *ngIf="config.showButtons">
    <td *ngIf="config.showNegative"></td>

    <td *ngIf="config.showYears">
      <a class="btn btn-link" id="dp-years-up" (click)="years = years + config.unitSteps.years" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </td>

    <td *ngIf="config.showMonths">
      <a class="btn btn-link" id="dp-months-up" (click)="months = months + config.unitSteps.months" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </td>

    <td *ngIf="config.showWeeks">
      <a class="btn btn-link" id="dp-weeks-up" (click)="weeks = weeks + config.unitSteps.weeks" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </td>

    <td *ngIf="config.showDays">
      <a class="btn btn-link" id="dp-days-up" (click)="days = days + config.unitSteps.days" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </td>

    <td *ngIf="config.showHours">
      <a class="btn btn-link" id="dp-hours-up" (click)="hours = hours + config.unitSteps.hours" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </td>

    <td *ngIf="config.showMinutes">
      <a class="btn btn-link" id="dp-minutes-up" (click)="minutes = minutes + config.unitSteps.minutes" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </td>

    <td *ngIf="config.showSeconds">
      <a class="btn btn-link" id="dp-seconds-up" (click)="seconds = seconds + config.unitSteps.seconds" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-up"></span>
      </a>
    </td>
  </tr>

  <tr>
    <td *ngIf="config.showNegative">
      <a
        class="btn btn-link status-container"
        id="dp-sign"
        (click)="negative = !negative"
        [ngClass]="{ 'disabled': disabled }"
      >
        <span *ngIf="!negative" class="bs-icon bs-icon-plus"></span>
        <span *ngIf="negative" class="bs-icon bs-icon-minus"></span>
      </a>
    </td>

    <td *ngIf="config.showYears">
      <input (blur)="onTouched()" type="number" placeholder="Y" id="dp-years" [(ngModel)]="years" [disabled]="disabled">
    </td>

    <td *ngIf="config.showMonths">
      <input (blur)="onTouched()" type="number" placeholder="M" id="dp-months" [(ngModel)]="months" [disabled]="disabled">
    </td>

    <td *ngIf="config.showWeeks">
      <input (blur)="onTouched()" type="number" placeholder="W" id="dp-weeks" [(ngModel)]="weeks" [disabled]="disabled">
    </td>

    <td *ngIf="config.showDays">
      <input (blur)="onTouched()" type="number" placeholder="D" id="dp-days" [(ngModel)]="days" [disabled]="disabled">
    </td>

    <td *ngIf="config.showHours">
      <input (blur)="onTouched()" type="number" placeholder="H" id="dp-hours" [(ngModel)]="hours" [disabled]="disabled">
    </td>

    <td *ngIf="config.showMinutes">
      <input (blur)="onTouched()" type="number" placeholder="M" id="dp-minutes" [(ngModel)]="minutes" [disabled]="disabled">
    </td>

    <td *ngIf="config.showSeconds">
      <input (blur)="onTouched()" type="number" placeholder="S" id="dp-seconds" [(ngModel)]="seconds" [disabled]="disabled">
    </td>

    <td *ngIf="config.showPreview">
      <span id="dp-duration-value">{{ preview }}</span>
    </td>
  </tr>

  <tr *ngIf="config.showButtons">
    <td *ngIf="config.showNegative"></td>

    <td *ngIf="config.showYears">
      <a class="btn btn-link" id="dp-years-down" (click)="years = years - config.unitSteps.years" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </td>

    <td *ngIf="config.showMonths">
      <a class="btn btn-link" id="dp-months-down" (click)="months = months - config.unitSteps.months" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </td>

    <td *ngIf="config.showWeeks">
      <a class="btn btn-link" id="dp-weeks-down" (click)="weeks = weeks - config.unitSteps.weeks" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </td>

    <td *ngIf="config.showDays">
      <a class="btn btn-link" id="dp-days-down" (click)="days = days - config.unitSteps.days" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </td>

    <td *ngIf="config.showHours">
      <a class="btn btn-link" id="dp-hours-down" (click)="hours = hours - config.unitSteps.hours" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </td>

    <td *ngIf="config.showMinutes">
      <a class="btn btn-link" id="dp-minutes-down" (click)="minutes = minutes - config.unitSteps.minutes" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </td>

    <td *ngIf="config.showSeconds">
      <a class="btn btn-link" id="dp-seconds-down" (click)="seconds = seconds - config.unitSteps.seconds" [ngClass]="{ 'disabled': disabled }">
        <span class="bs-chevron bs-chevron-down"></span>
      </a>
    </td>
  </tr>

  </tbody>
</table>
